import React, { useState } from 'react'
import './style.scss'


/**
 * A reusable modal dialog component with  customizable features
 * @param {Object} props - Component props
 * @param {'small'|'medium'|'large'} [props.size='medium'] - Controls the width of the modal
 * @param {Function} props.onClose - Callback function triggered when modal closes
 * @param {React.ReactNode} props.children - Content to be rendered inside modal body
 * @param {boolean} [props.centered=true] - Whether to center the modal vertically
 * @param {string} props.title - Text to display in the modal header
 * @param {Function} props.onSave - Callback function triggered when save button is clicked
 * @param {string} [props.saveBtnText='Save'] - Custom text for the save button
 * @param {boolean} [props.saveBtnDisabled=false] - Whether the save button should be disabled
 * @param {Boolean} [props.closeOnly=false] - whether to display save button or only close button
 * @returns {React.ReactElement} Modal component
 */
const OurModal = ({
    size = 'medium',
    onClose,
    children,
    centered = true,
    title,
    onSave,
    saveBtnText = 'Save',
    saveBtnDisabled = false,
    closeOnly = false
}) => {
    const [isExiting, setIsExiting] = useState(false);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setIsExiting(false);
            onClose();
        }, 500);
    };

    return (
        <>
            <div
                className={`our-modal-overlay ${isExiting ? 'exiting' : 'entering'}`}
                onClick={handleClose}
            >
                <div className={`our-modal-dialog ${size} ${centered ? 'centered' : ''}`}>
                    <div
                        className={`our-modal ${isExiting ? 'exiting' : 'entering'}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="our-modal-header">
                            <h2 className="our-modal-title">{title}</h2>
                            <button className="btn close-btn" onClick={handleClose}>
                                X
                            </button>
                        </div>

                        <div className="our-modal-body">
                            {children}
                        </div>

                        <div className="our-modal-footer">
                            <button className="btn close-btn" onClick={handleClose}>Close</button>
                            {closeOnly ? "" : (<button
                                className="btn save-btn"
                                onClick={onSave}
                                disabled={saveBtnDisabled}
                            >
                                {saveBtnText}
                            </button>)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OurModal